export default __webpack_public_path__ + "static/media/SAP.5f229661.svg";